import { useEffect, useRef } from 'react';
import DeviceTypeEdit from './DeviceTypeEdit';
import WebUniversal, { WebUniversalProps } from '../../system/WebUniversal';
import { columnsheadId } from '../../../utilsTsx/components/system/columnshead';
import { Tooltip } from 'antd';

const WebComponent = (props: any) => {
    const ref = useRef<any>(undefined);
    const apiId = 'deviceType';

    useEffect(() => { }, []);

    //表头
    const columnsHead = [
        {
            title: '类型',
            dataIndex: 'typeName'
        },
        {
            title: '编码',
            dataIndex: 'code'
        },
        {
            title: '描述',
            dataIndex: 'description',
            render: (val: string) =>
                <Tooltip placement="topLeft" title={val}>{
                    val?.length >= 8 ? val?.substring(0, 8) + '......' : val
                }</Tooltip>
        },
        {
            title: '排序',
            dataIndex: 'sort'
        },
    ];

    const columns = columnsheadId
        .concat(columnsHead as []);

    let extendProps: WebUniversalProps = {
        ...props,
        titleName: '设备类型',
        apiId,
        columns,
        serviceId: 'mf',
        editOptions: {
            Editor: DeviceTypeEdit
        }
    };

    return (<WebUniversal {...extendProps} ref={ref} />)
}

export default WebComponent;
